import { OrderDetailsView } from '@nexelem/graphne-api';

export const getClients = (orders?: OrderDetailsView[]) =>
  (orders || []).map(({ buyerName }) => buyerName).filter((buyerName): buyerName is string => !!buyerName);
